/**
 * Componente LanguageSelector para alternar entre idiomas na aplicação.
 *
 * Este componente permite ao usuário selecionar o idioma da interface,
 * utilizando Redux para gerenciar o estado do idioma e react-i18next
 * para aplicar as traduções.
 *
 * @module LanguageSelector
 */

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Selector } from './LanguageSelector.Styles';
import { changeLanguage } from '../../state/language/languageSlice';
import { useEffect } from 'react';

/**
 * Componente funcional que renderiza um seletor de idiomas.
 *
 * Utiliza Redux para gerenciar o estado do idioma selecionado e
 * react-i18next para aplicar as mudanças de idioma na aplicação.
 * Suporta inglês (en), português do Brasil (ptbr) e espanhol (es).
 *
 * @returns {JSX.Element} Componente de seleção de idioma
 */
const LanguageSelector = () => {
  // Obtém o idioma atual do estado Redux
  const language = useSelector((state) => state.language.value);
  const dispatch = useDispatch();

  // Hook de tradução do i18next
  const { t, i18n } = useTranslation();

  /**
   * Manipula a mudança de idioma quando o usuário seleciona uma opção.
   *
   * @param {Object} event - Evento de mudança do select
   */
  function handleChange(event) {
    console.log('handleChange: ', event.target.value);
    dispatch(changeLanguage(event.target.value));
  }

  /**
   * Efeito que atualiza o idioma no i18n quando o estado do Redux muda.
   */
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);

  return (
    <Selector>
      <select value={language} name="languages" onInput={handleChange}>
        <option value="en">{t('en')}</option>
        <option value="ptbr">{t('ptbr')}</option>
        <option value="es">{t('es')}</option>
      </select>
    </Selector>
  );
};

export default LanguageSelector;
